export const USER_LIMIT_EXCEEDED_ERROR_CODE = 'USER_LIMIT_EXCEEDED'

export const getGraphQLErrorCode = (error: unknown): string | undefined =>
  (
    error as {
      graphQLErrors?: Array<{ extensions?: { code?: string } }>
    }
  )?.graphQLErrors?.[0]?.extensions?.code
